<template>
  <div align="center" v-if="item">
    <v-dialog ref="dialog" v-model="modal2" persistent max-width="1000px">
      <template v-slot:activator="{ props }">
        <v-btn
          :disabled="item.Protegido"
          color="blue-grey-darken-1"
          dark
          @click="
            this.getNumeroSolicitudDato();
            item.ValorAlfaNumerico = '0';
          "
          prepend-icon="mdi-clipboard-account"
          size="x-large"
          v-bind="props"
        >
          {{ item.Label }}
        </v-btn>
        <v-tooltip location="bottom">
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              size="x-large"
              :color="selected.length == 0 ? 'red-accent-4' : 'green'"
            >
              {{
                selected.length == 0
                  ? "mdi-account-cancel"
                  : "mdi-account-arrow-up"
              }}</v-icon
            >
          </template>
          <span>
            {{
              selected.length == 0
                ? "No se ha cargado usuario asignado"
                : selected.DescUser
            }}
          </span>
        </v-tooltip>
      </template>
      <v-card>
        <v-toolbar dark color="red-darken-4">
          <v-btn
            icon
            dark
            @click="
              modal2 = false;
              clear();
            "
          >
            <v-icon>mdi-close </v-icon>
          </v-btn>
          <v-toolbar-title
            ><v-icon left>mdi-clipboard-account</v-icon>
            {{ item.Label }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="d-none d-md-block" dark text @click="save()"
              >Guardar</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row align="center" justify="start" v-if="item.TipoDato == 17">
              <v-col cols="12" sm="12" md="12">
                Proceso Asignar: {{ this.asignar.ProcesoAsignar }} -
                {{ this.asignar.DescProcesoAsignar }}
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  item-key="ID_Registro"
                  class="elevation-1"
                >
                  <template v-slot:item.Asignado="{ item }">
                    <v-checkbox-btn
                      v-model="item.raw.Asignado"
                      @change="selectuser(item.raw)"
                    ></v-checkbox-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <div class="d-flex align-center flex-column">
          <!-- Linea de progreso -->
          <v-dialog v-model="progreso" persistent width="auto">
            <v-card color="red-darken-4">
              <v-card-text>
                Espera un momento...
                <v-toolbar align="center" color="red-darken-4">
                  <v-img
                    class="mx-auto"
                    :width="5"
                    src="/static/iconos/logo2.png"
                  ></v-img>
                </v-toolbar>
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import store from "@/store";
export default {
  name: "datepicker-modal",
  data() {
    return {
      item: this.infoCampo,
      progreso: false,
      modal2: false,
      selected: [],
      asignar: [],
      headers: [
        { title: "Asignado", key: "Asignado", sortable: false },
        { title: "Usuario", key: "DescUser" },
        { title: "Pefil", key: "DescPerfil_ID" },
      ],
      desserts: [],
    };
  },
  props: {
    infoCampo: {
      type: Object,
      default: null,
      Description: "Información del campo tipo Datepicker para ser añadido",
    },
    acceso: {
      type: String,
      default: "",
      Description: "Conocer el acceso a la acción manual",
    },
    dataIni: {
      type: Object,
      default: null,
      Description: "Cabecera del dato de asignación manual",
    },
  },
  methods: {
    // Consulta Numero de Solitud Dato
    async getNumeroSolicitudDato() {
      this.selected = [];
      this.desserts = [];
      this.axios
        .get(
          "/Procesos/Asignaciones/GetCD1AsigancionManual/" +
            this.dataIni.solicitud +
            "/" +
            this.dataIni.linea +
            "/" +
            this.dataIni.proceso +
            "/" +
            this.infoCampo.Dato
        )
        .then((result) => {
          this.asignar = result.data;
          if (this.asignar.UsuarioPerfil.length > 0) {
            this.desserts = this.asignar.UsuarioPerfil;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Guardado de datos
    async save() {
      if (this.selected != [] && this.selected != null && this.selected != 0) {
        this.progreso = true;
        var userperfil = this.$store.getters.userperfil.userInfo;
        var data = {
          Solicitud: this.dataIni.solicitud,
          LineaAsignar: this.asignar.LineaAsignar,
          ProcesoAsignar: this.asignar.ProcesoAsignar,
          User: this.selected.User,
          Perfil_ID: this.selected.Perfil_ID,
          Asignado: true,
          UserLogin: userperfil.Usuario_ID,
        };
        this.axios
          .post("/Procesos/Asignaciones/PostManual/", data)
          .then((response) => {
            if (response.data == "Exito") {
              this.$swal({
                icon: "success",
                title: "¡Éxito!",
                html: "Los datos han sido guardados correctamente, por favor revisar",
              });
              this.item.ValorAlfaNumerico = this.selected.DescUser;
              this.modal2 = false;
              this.$store.commit("infoprocesodato", this.item);
              this.$store.commit("infoCampo", this.item);
            }
          })
          .catch((error) => {
            this.item.ValorAlfaNumerico = "0";
            this.$store.commit("infoprocesodato", this.item);
            const registro = error.response.data;
            const mensajeerror = registro.Mensaje || registro.ExceptionMessage;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: " [404] No existen datos para esta consulta.",
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      } else {
        this.$swal({
          icon: "warning",
          title: "Selección Inválida",
          html: "Por favor, selecciones uno de los usuarios de la lista para asignar",
        });
      }
    },
    //Limpieza de campos
    clear() {
      this.selected = [];
      this.desserts = [];
      this.item.ValorAlfaNumerico = "0";
      this.$store.commit("infoprocesodato", this.item);
    },
    // Asignacion Seleccionado Usuario
    selectuser(item) {
      if (item.Asignado) {
        this.selected = item;
        var data = this.desserts;
        for (var i = 0; i < data.length; i++) {
          if (data[i].ID_Registro != item.ID_Registro) {
            data[i].Asignado = false;
          }
        }
        this.desserts = [];
        this.desserts = data;
      } else {
        this.selected = [];
        this.item.ValorAlfaNumerico = "0";
        this.$store.commit("infoprocesodato", this.item);
      }
    },
  },

  mounted() {
    this.clear();
  },
};
</script>
